if (!customElements.get('wepbio-card-slider')) {
  customElements.define(
    'wepbio-card-slider',
    class WepbioCardSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-slider-track]');
        this.cards = [...this.querySelectorAll('[data-slider-card]')];
        this.dots = [...this.querySelectorAll('[data-slider-dot]')];

        if (!this.track || this.cards.length < 2) return;

        this.frame = null;
        this.track.addEventListener('scroll', () => this.queueUpdate(), { passive: true });
        this.dots.forEach((dot, index) => {
          dot.addEventListener('click', () => this.goTo(index));
        });

        this.addEventListener('shopify:block:select', (event) => {
          const card = event.target.closest('[data-slider-card]');
          const index = this.cards.indexOf(card);
          if (index >= 0) this.goTo(index);
        });

        this.resizeObserver = new ResizeObserver(() => this.queueUpdate());
        this.resizeObserver.observe(this.track);
        this.updateDots();
      }

      disconnectedCallback() {
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }

      queueUpdate() {
        if (this.frame) cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.updateDots();
        });
      }

      goTo(index) {
        const card = this.cards[index];
        if (!card) return;

        const behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        this.track.scrollTo({ left: card.offsetLeft - this.track.offsetLeft, behavior });
      }

      updateDots() {
        const trackLeft = this.track.getBoundingClientRect().left;
        let activeIndex = 0;
        let closestDistance = Infinity;

        this.cards.forEach((card, index) => {
          const distance = Math.abs(card.getBoundingClientRect().left - trackLeft);
          if (distance < closestDistance) {
            closestDistance = distance;
            activeIndex = index;
          }
        });

        this.dots.forEach((dot, index) => {
          const active = index === activeIndex;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-current', active ? 'true' : 'false');
        });
      }
    }
  );
}
